export default "__VITE_ASSET__68f4b57d__"